import { useRef, useState } from "react";
const useOpen = (type = "modal") => {
  const [visible, setVisible] = useState(false);
  const recordRef = useRef({});
  const open = (record) => {
    recordRef.current = record || {};
    setVisible(true);
  };
  const close = () => {
    setVisible(false);
  };
  const compProps = {
    open: visible,
    onOk: close,
    onCancel: close,
    onClose: close,
    // Drawer 组件使用
    maskClosable: type === "drawer",
    closable: type === "modal",
    record: recordRef.current
  };
  return { open, close, compProps };
};
var useOpen_default = useOpen;
export {
  useOpen_default as default
};
